import { ActionEventType, ActionType, CipoTableOptions, TableRow } from '@shared/components/data-list/common';

export interface HeaderFooter {
  id: number;
  name: string;
  description: string;
  content: string;
  height: number;
  isGlobal: boolean;
  isHeader: boolean;
}

export interface HeaderFooterRow extends HeaderFooter, TableRow {
  _isHeader: string;
}

export interface HeaderFooterTemplate {
  key: number;
  value: string;
  isUsed: boolean;
  isDisabled: boolean;
  isPending: boolean;
  isHeader: boolean;
}

export enum HeaderFooterActionsEnum {
  EDIT = 1,
  DELETE = 2,
}

export type HeaderFooterAction = ActionType<HeaderFooterActionsEnum, HeaderFooterRow>;
export type HeaderFooterActionEvent = ActionEventType<HeaderFooterActionsEnum, HeaderFooterRow>;
export type HeaderFooterTableOptions = CipoTableOptions<HeaderFooterAction>;

export interface EditHeaderFooterDialogData {
  item?: HeaderFooter;
  canUpdate: boolean;
  isHeader: boolean;
  moduleId: number;
}

export interface SetDefaultsDialogData {
  canUpdate: boolean;
}

export interface BulkAssignPayload {
  id: number;
  templates: HeaderFooterTemplate[];
}
